<template>
  <v-dialog v-model="dialog" scrollable width="500">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary">{{$t('DataHome.edit')}}</v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >{{$t('DataHome.edit-property-value')}}</v-card-title>

      <v-card-text>
        <v-container>
          <v-row v-if="!object" align="center">
            <v-col cols="12" sm="7">
              <template v-if="string">
                <div class="text-subtitle-2 mb-2" v-text="property"></div>
                <v-text-field solo v-model="propertyValue"></v-text-field>
              </template>
              <template v-if="number">
                <div class="text-subtitle-2 mb-2" v-text="property"></div>
                <v-text-field :rules="[rules.number, rules.required]" solo v-model="propertyValue"></v-text-field>
              </template>
              <template v-if="boolean">
                <div class="text-subtitle-2 mb-2" v-text="property"></div>
                <v-select :items="[true,false]" v-model="propertyValue" solo></v-select>
              </template>
            </v-col>
          </v-row>
          <template v-if="object">
            <div class="text-subtitle-2 mb-2" v-text="property"></div>
            <v-card :elevation="2" class="pa-3">
              <vue-json-pretty :data="propertyValue"></vue-json-pretty>
            </v-card>
            <br />
            <v-jsoneditor
              v-model="propertyValue"
              :plus="false"
              :options="{ mode: 'code', enableTransform: false }"
              :height="'300px'"
            ></v-jsoneditor>
            <br />
          </template>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('DeviceTypes.back')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('DeviceTypes.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

import VueJsonPretty from "vue-json-pretty";
import VJsoneditor from "v-jsoneditor/src/index";

export default {
  components: {
    VueJsonPretty,
    VJsoneditor
  },
  props: {
    prop: Object,
    id: String
  },
  data() {
    return {
      dialog: false,
      property: "",
      propertyValue: "",
      boolean: false,
      number: false,
      string: false,
      object: false,
      rules: {
        required: value => !!value || this.$t("DataHome.property.required"),
        number: value => {
          return (
            !isNaN(Number(value)) || this.$t("DataHome.property.number-rule")
          );
        }
      }
    };
  },
  watch: {
    dialog: function() {
      this.property = this.prop.property;
      this.propertyValue = this.prop.value;
      this.boolean = false;
      this.number = false;
      this.string = false;
      this.object = false;
      switch (this.prop.type) {
        case "boolean":
          this.boolean = true;
          break;
        case "string":
          this.string = true;
          break;
        case "number":
          this.number = true;
          break;
        case "object":
          this.object = true;
          break;
      }
    }
  },
  methods: {
    save: function() {
      let value;

      switch (this.prop.type) {
        case "boolean":
          value = this.propertyValue == true;
          break;
        case "string":
          value = this.propertyValue;
          break;
        case "number":
          value = Number(this.propertyValue);
          break;
        case "object":
          value = JSON.parse(JSON.stringify(this.propertyValue));
          break;
      }
      axios
        .put(
          process.env.VUE_APP_API_ADDR +
            "/api/device/" +
            this.id +
            "/deviceTypeProperty",
          {
            properties: [
              {
                property: this.property,
                value: value
              }
            ]
          },
          {
            headers: { Authorization: tokenStore.getToken() }
          }
        )
        .then(res => {
          if (res.data.success) {
            this.dialog = false;
            this.$emit("reload");
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    }
  }
};
</script>